var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.base, ( _obj = {}, _obj[_vm.$style.inline] = _vm.inline, _obj )]},[_c('svg',{class:_vm.$style.svg,attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{class:[_vm.$style.circle, ( _obj$1 = {}, _obj$1[_vm.$style.light] = _vm.light, _obj$1 )],attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }